"use client";

import React from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { Typography, TextType } from "@components/atoms/typography/typography";
import { Button, ButtonType } from "@components/atoms/buttons/button";
import { SupportWidgetButton } from "@components/atoms/buttons/supportWidgetButton";
import { useUnit } from "effector-react";
import { $isApp } from "@features/launch-context/model";
import { getAppOnboardingPath } from "@utils/getAppOnboardingPath";
import { useT } from "@features/hooks";

export default function NotFound() {
    const router = useRouter();
    const t = useT();

    const isApp = useUnit($isApp);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-6 py-24 lg:px-8 text-center bg-white-900">
            <Image
                src="/images/404.png"
                alt="404"
                width={440}
                height={440}
                priority
                className="w-[220px] sm:w-[440px] h-auto"
            />
            <div className="mt-3 w-full max-w-[720px]">
                <Typography type={TextType.SUB_CAPTION} position="center" color="black" marginBottom="8px">
                    {t("Not found")}
                </Typography>
                <Typography type={TextType.PARAGRAPH} position="center">
                    {t("Sorry, we couldn’t find the page you’re looking for.")}
                </Typography>
            </div>
            <div className="mt-8 flex items-center justify-center gap-4 flex-col sm:flex-row">
                <Button
                    type={ButtonType.BUTTON_BASE}
                    color="blue"
                    className="!mt-0 !px-5 !py-3 !w-auto"
                    onClick={() => router.push(isApp ? getAppOnboardingPath("ios") : "/")}
                >
                    {t("Go back home")}
                </Button>
                <SupportWidgetButton>
                    <Typography type={TextType.LINK}>
                        {t("Contact support")} <span className="inline-block rtl:-scale-x-100">→</span>
                    </Typography>
                </SupportWidgetButton>
            </div>
        </div>
    );
}
